import React from 'react';
import GalaxyBackground from './components/GalaxyBackground';
import Hero from './components/Hero'
import Header from './header';
import './variables.module.scss';
import HumanShow from './components/HumanShow';

const HomePage: React.FC = () => {
  return (
    <div>
      <GalaxyBackground />
      <Header />      
      <Hero />
      <HumanShow />
    </div>
  );
};

export default HomePage;